import React, { FC } from 'react'
import styled from 'styled-components'


type Props = {
    index: number
    color: string
    val: string
  };


export const Option: FC<Props> = ({val, index, color}) => {
    return (
        <Container index={index} color={color} val={val}>
            <Wrap>
                {val}
            </Wrap>
        </Container>
    )
}

const Container = styled.div<Props>`
    position: absolute;
    top: 43.8%;
    left: 0.2%;
    /* width: 30vh;
    height: 5vh; */
    transform-origin: center right;
    border-left: 30vh solid ${props => props.color};
    border-top: 4vh solid transparent;
    border-bottom: 4vh solid transparent;
    border-right: none;
    box-sizing: border-box;
    transform: rotate(${props => props.index * 15}deg);
    padding-left: 3%;
    font-size: 2vh;
    line-height: 0;
`
const Wrap = styled.div`
    position: absolute;
    right: 10vh;
    text-align: left;
    width: 20vh;
    user-select: none;
    font-weight: 700;
`